module.exports = __webpack_public_path__ + "img/approve_bg.41992b0c.png";